// extracted by mini-css-extract-plugin
module.exports = {"imgCellsWithText":"ImgCellsWithText_imgCellsWithText__DdE5B"};